<template>
  <svg
    viewBox="0 0 200 150"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    class="h-full w-full"
  >
    <defs>
      <filter id="spear-glow" x="-50%" y="-50%" width="200%" height="200%">
        <feDropShadow
          dx="0"
          dy="2"
          stdDeviation="6"
          flood-color="#a78bfa"
          flood-opacity="0.5"
        />
      </filter>
    </defs>

    <!-- Target/crosshair rings -->
    <circle
      cx="100"
      cy="75"
      r="40"
      fill="none"
      stroke="#ede9fe"
      stroke-width="1"
    />
    <circle
      cx="100"
      cy="75"
      r="28"
      fill="none"
      stroke="#e9d5ff"
      stroke-width="1"
      stroke-dasharray="4 4"
      class="rotate"
    />
    <circle
      cx="100"
      cy="75"
      r="16"
      fill="#f5f3ff"
      stroke="#c4b5fd"
      stroke-width="1"
    />

    <!-- Shield center -->
    <g filter="url(#spear-glow)">
      <circle cx="100" cy="75" r="10" fill="#7c3aed" />
      <path
        d="M100 69 L105 72 L105 77 C105 80 100 82 100 82 C100 82 95 80 95 77 L95 72 Z"
        fill="white"
      />
    </g>

    <!-- Crosshair lines -->
    <line
      x1="100"
      y1="30"
      x2="100"
      y2="50"
      stroke="#c4b5fd"
      stroke-width="1"
      class="pulse"
    />
    <line
      x1="100"
      y1="100"
      x2="100"
      y2="120"
      stroke="#c4b5fd"
      stroke-width="1"
      class="pulse delay1"
    />
    <line
      x1="55"
      y1="75"
      x2="75"
      y2="75"
      stroke="#c4b5fd"
      stroke-width="1"
      class="pulse delay2"
    />
    <line
      x1="125"
      y1="75"
      x2="145"
      y2="75"
      stroke="#c4b5fd"
      stroke-width="1"
      class="pulse delay3"
    />
  </svg>
</template>

<style scoped>
@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
@keyframes pulse {
  0%,
  100% {
    opacity: 0.5;
  }
  50% {
    opacity: 1;
  }
}
.rotate {
  animation: rotate 20s linear infinite;
  transform-origin: 100px 75px;
}
.pulse {
  animation: pulse 2s ease-in-out infinite;
}
.delay1 {
  animation-delay: 0.5s;
}
.delay2 {
  animation-delay: 1s;
}
.delay3 {
  animation-delay: 1.5s;
}
</style>
